<template>
  <div :class="showPageRecord ? 'pagination-wrap' : ''">
    <div class="css-controls">
      <div class="page-size-select">
        <label for="pageSize">Rows per page:</label>
        <select id="pageSize" v-model="selectedPageSize" @change="updatedPageSize">
          <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
        </select>
      </div>
      <div class="page-record" v-if="from && to && total && showPageRecord">
        <span>Showing {{ from }} to {{ to }} of {{ total }} results</span>
      </div>
    </div>

    <div class="table-pagination" v-if="total > perPage">
      <b-pagination v-model="currentPage" :total-rows="total" :per-page="selectedPageSize" align="right"
        prev-text="Prev" next-text="Next" first-text="First" last-text="Last" @change="handlePageChange">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import Helper from "@/resource/Helper";
import axios from "axios";

export default {
  name: "Pagination",
  props: {
    rows: {
      required: true,
    },
    filters: {
      default() {
        return {};
      },
    },
    showPageRecord: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      items: [],
      filterParams: {},
      selectedPageSize: 10,
      currentPage: 1,
      pageSizes: [10, 25, 50, 75, 100],
      shouldFetch:false,
    };
  },

  methods: {
    handlePageChange(page) {
      this.shouldFetch = true;
      this.currentPage = page;
      this.getData();
    },
    async getData() {
      if (!this.shouldFetch) return;
      const url = `${this.items.path}?page_size=${this.selectedPageSize}&page=${this.currentPage}${this.filterQuery ? `&${this.filterQuery}` : ''}`;

      let loader = this.$loading.show();

      try {
        const response = await axios.get(url);
        const result = response.data;

        const paginationData = result; 

        // Update parent component
        this.$emit("update:rows", paginationData);

        // Set items with actual pagination info
        this.items = {
          ...paginationData,
        };

        this.currentPage = paginationData.current_page;
        this.selectedPageSize = paginationData.per_page;

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        loader.hide();
      }
    }
    ,

    updatedPageSize() {
      this.shouldFetch = true;
      this.currentPage = 1;
      this.getData();
    },
  },

  mounted() {
    this.$root.$on("searchEvent", (data) => {
      this.filterParams = data;
      this.currentPage = 1;
      this.getData();
    });
  },

  computed: {
    perPage() {
      return this.selectedPageSize;
    },
    filterQuery() {
      let filtersCopy = { ...this.filterParams };
      if (Array.isArray(filtersCopy.reason) && filtersCopy.reason.length) {
        if (typeof filtersCopy.reason[0] === 'object' && filtersCopy.reason[0] !== null) {
          filtersCopy.reason = filtersCopy.reason.map(r => r.value).join(',');
        } else {
          filtersCopy.reason = filtersCopy.reason.join(',');
        }
      }
      return Helper.objToUrlParams(filtersCopy);
    },
    from() {
      return this.items.from;
    },
    to() {
      return this.items.to;
    },
    total() {
      return this.items.total;
    },
  },

  created() {
    if (this.rows?.data) {
      this.items = this.rows;
    }
    this.filterParams = this.filters;
  }
  ,

  watch: {
    rows(value) {
    if (value?.data) {
      this.items = value;
      this.selectedPageSize = value.per_page;
      this.currentPage = value.current_page;
    }
  },
    filters(value) {
      this.filterParams = value;
      this.currentPage = 1;
      this.getData();
    },
  },
};
</script>